import {SalesDashboardRepository} from '../repository/SalesDashboardRepository';
import type {BaseResponse} from '../../../Data/types/BaseResponse';

export class GetPendingBankTransfersUseCase {
  constructor (private readonly repo: SalesDashboardRepository) {}

  async execute (params: {page?: number; limit?: number}): Promise<BaseResponse<any[]>> {
    return this.repo.getPendingBankTransfers(params);
  }
}


